<template>
<div class="app">
  <router-view></router-view>
  <SurveyPopup/>
</div>
</template>
<script>
import SurveyPopup from '@/components/SurveyPopup.vue'

export default {
  name: "app",
  components: {
    SurveyPopup,
  },
  created() {
    this.$store.getters.api.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status == 401) {
        if(this.$router.currentRoute.path != "/retencion"){
          this.$store.dispatch('user/logout')
          this.$router.push('/login');
        }
      }
      return Promise.reject(error);
    });
    //si recargo la pagina validamos que no tenga cambio de contraseña
    if(this.$store.state.user.cambiar_clave == null){
      this.validacion_cambiar_clave();
    }
  },
  data() {
  },
  methods:{
    async validacion_cambiar_clave() {
      try {
        await this.$store.state.api
          .get("mfa/datos_usuario", )
          .then((response) => {
            const usuario = response.data;
            //no lo deja navegar si tiene cambio de clave && this.$route.path != "/cambio-pass"
            if(usuario.cambiar_clave == "1" ){
              this.$store.commit("user/SET_CAMBIAR_CLAVE", true);
            }
            if(usuario.cambiar_clave == "1" && this.$router.currentRoute.path != '/cambio-pass'){
              this.$router.push({ path: "/cambio-pass" });
            }
            
          })
          .catch((err) => {
          });
        } catch (err) {}
    }
  }
};
</script>

<style lang="scss">
  @import 'assets/scss/style';
</style>




